var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-1", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Per page" } },
                [
                  _c("b-form-select", {
                    attrs: {
                      id: "perPageSelect",
                      options: _vm.pageOptions.map(function (option) {
                        return { text: option, value: option }
                      }),
                      size: "sm",
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "mb-1", attrs: { cols: "12", sm: "3" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Search" } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filterInput",
                          type: "search",
                          placeholder: "Type to Search",
                        },
                        on: { input: _vm.onSearch },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.searchQuery },
                              on: {
                                click: function ($event) {
                                  _vm.searchQuery = ""
                                },
                              },
                            },
                            [_vm._v(" Clear ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end my-1",
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("add-segment-modal")
                    },
                  },
                },
                [_vm._v(" Add Segment ")]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              !_vm.loading
                ? _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      items: _vm.filteredLeads,
                      fields: _vm.fields,
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(view_customer)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.ViewCustomersBySegment(
                                        data.item
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" View Customer ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    variant: "link",
                                    "toggle-class": "text-decoration-none",
                                    "no-caret": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle mr-25",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.prepareEditLead(data.item)
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "EditIcon" },
                                      }),
                                      _c("span", [_vm._v("Edit")]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteFeedback(
                                            data.item.segmentId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "TrashIcon" },
                                      }),
                                      _c("span", [_vm._v("Delete")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      434098876
                    ),
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              !_vm.loading
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: { id: "add-segment-modal", title: "Add Segment" },
              on: {
                ok: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                },
                hidden: _vm.resetForm,
              },
              scopedSlots: _vm._u([
                {
                  key: "modal-footer",
                  fn: function (ref) {
                    var ok = ref.ok
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            disabled: _vm.submitting,
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [
                          _vm.submitting
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(_vm.submitting ? "Adding..." : "Add") +
                              " "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "mb-3",
                          attrs: { title: "Add Segment" },
                        },
                        [
                          _c(
                            "validation-observer",
                            { ref: "AddForm" },
                            [
                              _c(
                                "b-form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onSubmit($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Segment Name:",
                                        "label-for": "lead-name",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Segment Name",
                                          vid: "Segment Name",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "lead-name",
                                                    type: "text",
                                                    placeholder:
                                                      "Enter Segment name",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.form.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: { id: "edit-segment-modal", title: "Edit Segment" },
              on: {
                ok: function ($event) {
                  $event.preventDefault()
                  return _vm.onEditSubmit($event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "modal-footer",
                  fn: function (ref) {
                    var ok = ref.ok
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            disabled: _vm.submitting,
                          },
                          on: { click: _vm.onEditSubmit },
                        },
                        [
                          _vm.submitting
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.submitting ? "Updating..." : "Update"
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "mb-3",
                          attrs: { title: "Edit Segment" },
                        },
                        [
                          _c(
                            "validation-observer",
                            { ref: "EditForm" },
                            [
                              _c(
                                "b-form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onEditSubmit($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Segment Name:",
                                        "label-for": "edit-lead-first-name",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Segment Name",
                                          vid: "Segment Name",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "edit-lead-first-name",
                                                    type: "text",
                                                    placeholder:
                                                      "Enter Segment name",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.editForm.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editForm,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "editForm.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }